module.exports = __webpack_public_path__ + "img/grupo2.f67d9b1f.svg";